import { FC } from 'react';
import { css } from '@emotion/react';
import { Button } from '@frontend/design-system';
import { ButtonAlignment, ButtonType } from '../../../../../../types/form-template.types';

interface ButtonFieldProps {
  id: string;
  label: string;
  fieldKey: string;
  buttonType?: ButtonType;
  align?: ButtonAlignment;
  onClick: () => void;
}

const getContainerStyles = (alignment: ButtonAlignment = 'left') => css`
  width: 100%;
  display: flex;
  justify-content: ${alignment === 'center' ? 'center' : alignment === 'right' ? 'flex-end' : 'flex-start'};
`;

export const ButtonField: FC<ButtonFieldProps> = ({
  id,
  label,
  fieldKey,
  buttonType = 'primary',
  align = 'left',
  onClick,
}) => {
  return (
    <div data-field-id={id} css={getContainerStyles(align)}>
      <Button variant={buttonType} type='button' trackingId={`${fieldKey}-button-action`} onClick={onClick}>
        {label}
      </Button>
    </div>
  );
};
